import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { AssetCategory } from '../../models/AssetCategory';
import { Observable } from 'rxjs';
import { ApiResponse } from '@card-software/nexus-utilities';

@Injectable({
  providedIn: 'root',
})
export class CategoryProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.assetApi + '/api/v1/category';

  getCategories(): Observable<ApiResponse<AssetCategory[]>> {
    return this.httpClient.get<ApiResponse<AssetCategory[]>>(`${this.baseUrl}/all`);
  }

  upsertCategory(category: AssetCategory): Observable<ApiResponse<AssetCategory>> {
    return this.httpClient.post<ApiResponse<AssetCategory>>(`${this.baseUrl}`, category);
  }
}
